var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalWithTrigger", {
    attrs: { title: "Add credit card" },
    scopedSlots: _vm._u([
      {
        key: "trigger",
        fn: function ({ openModal }) {
          return [
            _c("UiButton", {
              attrs: { buttonText: "Add Credit Card" },
              on: { click: openModal },
            }),
          ]
        },
      },
      {
        key: "default",
        fn: function ({ closeModal }) {
          return [
            _c("AddPaymentCardForm", {
              attrs: {
                buttonText: "Add Credit Card",
                currentUserId: _vm.currentUserId,
                outerProcessing: _vm.processing,
                outerErrorMessage: _vm.errorMessage,
              },
              on: { addCard: (card) => _vm.addCard(card, closeModal) },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ addCard, disabled }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _c("UiButton", {
                              staticClass: "mr-3",
                              attrs: {
                                buttonText: _vm.actionButtonText,
                                disabled: disabled,
                                processing: _vm.processing,
                              },
                              on: { click: addCard },
                            }),
                            _c("UiButton", {
                              attrs: {
                                buttonText: "Cancel",
                                variant: "outline",
                              },
                              on: { click: closeModal },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }